import { Col, Row, Typography } from "antd";
import { connect, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { StyledButton } from "../../styled-components/components";
import {
  PlusOutlined,
  CheckOutlined,
  LoadingOutlined,
  CloseCircleFilled,
} from "@ant-design/icons";
import { fetchAllSkills, addSkills } from "../../Redux/Consultant/reducer";
import { StyledCheckTag } from "../../styled-components/components";
import Feedback from "../../Utilities/Feedback";
import constants from "../../Redux/constants";
import SearchBar from "../../Utilities/SearchBar";

const AddSkills = (props) => {
  const [fetchingSkills, setFetchingSkills] = useState(true);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [addingSkills, setAddingSkills] = useState(false);
  const [searchSkills, setSearchSkills] = useState([]);
  const [searching, setSearching] = useState(false);
  const allSkills = useSelector((state) => state.consultantStore.allSkills);
  const { fetchAllSkills, addSkills } = props;
  useEffect(() => {
    const getAllSkills = async () => {
      const responseStatus = await fetchAllSkills();
      if (responseStatus === constants.status.success) {
        setFetchingSkills(false);
      }
    };
    getAllSkills();
  }, [fetchAllSkills]);
  const closeModal = () => {
    props.closeModal();
  };
  const addUserSkills = async () => {
    setAddingSkills(true);
    const responseStatus = await addSkills(selectedSkills);
    props.fetchAllSkills();
    if (responseStatus === constants.status.success) {
      setAddingSkills(false);
      props.closeModal();
    }
  };
  const addSkill = (id) => {
    const isSkill = selectedSkills.indexOf(id);
    if (isSkill === -1) {
      setSelectedSkills([...selectedSkills, id]);
    }
  };
  const isChecked = (id) => {
    const isSkill = selectedSkills.indexOf(id);
    if (isSkill > -1) {
      return true;
    }
    return false;
  };
  const getSearchText = (searchText) => {
    setSearching(true);
    const text = new RegExp(searchText, "i");
    const searchingSkills = allSkills.filter((skill) =>
      skill.name.toString().match(text)
    );
    setSearchSkills([...searchingSkills]);
  };
  const showAllSkills = () => {
    setSearching(false);
  };
  const removeSkill = (id) => {
    const allSkills = selectedSkills.filter((skillId) => skillId !== id);
    setSelectedSkills([...allSkills]);
  };
  return (
    <Col>
      <Row style={{ marginBottom: "4vh" }}>
        <Typography.Title level={4}>Add Skills</Typography.Title>
      </Row>
      {fetchingSkills ? (
        <Feedback title="Loading all skills" icon={<LoadingOutlined />} />
      ) : (
        <>
          {addingSkills ? (
            <Feedback title="Adding skills" icon={<LoadingOutlined />} />
          ) : (
            <Col>
              <Row>
                <SearchBar
                  searchHolder="Search Skills"
                  getSearchText={getSearchText}
                  showAllSkills={showAllSkills}
                ></SearchBar>
              </Row>
              {searching ? (
                <Row>
                  {searchSkills &&
                    searchSkills.map((eachSkill) => (
                      <Row key={eachSkill.id}>
                        <Col>
                          <StyledCheckTag
                            data-testId={`tag-${eachSkill.id}`}
                            key={eachSkill.id}
                            checked={isChecked(eachSkill.id)}
                            onClick={() => addSkill(eachSkill.id)}
                          >
                            {isChecked(eachSkill.id) ? <CheckOutlined /> : null}
                            {eachSkill.name}{" "}
                            {isChecked(eachSkill.id) ? null : <PlusOutlined />}
                            {isChecked(eachSkill.id) ? (
                              <CloseCircleFilled
                                onClick={() => removeSkill(eachSkill.id)}
                              />
                            ) : null}
                          </StyledCheckTag>
                        </Col>
                      </Row>
                    ))}
                </Row>
              ) : (
                <Row>
                  {allSkills.map((eachSkill) => (
                    <Row key={eachSkill.id}>
                      <Col>
                        <StyledCheckTag
                          data-testId={`tag-${eachSkill.id}`}
                          key={eachSkill.id}
                          checked={isChecked(eachSkill.id)}
                          onClick={() => addSkill(eachSkill.id)}
                        >
                          {isChecked(eachSkill.id) ? <CheckOutlined /> : <></>}
                          {eachSkill.name}{" "}
                          {isChecked(eachSkill.id) ? (
                            <></>
                          ) : (
                            <PlusOutlined data-testid="submit-addSkill" />
                          )}
                          {isChecked(eachSkill.id) ? (
                            <CloseCircleFilled
                              data-testid="submit-removeSkill"
                              onClick={() => removeSkill(eachSkill.id)}
                            />
                          ) : null}
                        </StyledCheckTag>
                      </Col>
                    </Row>
                  ))}
                </Row>
              )}

              <Row style={{ marginTop: "2vh" }} justify="space-between">
                <Col>
                  <StyledButton
                    color="#d92626"
                    onClick={closeModal}
                    data-testid="submit-cancel"
                  >
                    Cancel
                  </StyledButton>
                </Col>
                <Col>
                  <StyledButton
                    onClick={addUserSkills}
                    data-testid="submit-addSkill"
                  >
                    Add
                  </StyledButton>
                </Col>
              </Row>
            </Col>
          )}
        </>
      )}
    </Col>
  );
};

const mapDisptachToProps = (dispatch) => {
  return {
    fetchAllSkills: () => dispatch(fetchAllSkills()),
    addSkills: (selectedSkills) => dispatch(addSkills(selectedSkills)),
  };
};

export default connect(null, mapDisptachToProps)(AddSkills);
